import {Component, NgZone} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MessageService} from './core/service/message.service';
import {InfoMessageComponent} from './shared/dialog/info-message/info-message.component';
import {ErrorMessageComponent} from './shared/dialog/error-message/error-message.component';
import {MainWindowComponent} from './core/main-window/main-window.component';
import {ResizeService} from './core/service/resize.service';
import {NavigationEnd, Router} from '@angular/router';
import {browserLanguage, translateLanguage} from '../nbassist/functions/language';
import {TranslateService} from '@ngx-translate/core';
import {DateAdapter} from '@angular/material/core';
import {firstValueFrom} from 'rxjs';
import {LoggingService} from './core/service/logging.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends MainWindowComponent {
  title = 'farm-manager';
  hover = false;
  currentRootRoute = 'auth';
  constructor(private messageService: MessageService,
              private messageBar: MatSnackBar,
              private ngZone: NgZone,
              private resizeService: ResizeService,
              public dateAdapter: DateAdapter<any>,
              public translateService: TranslateService,
              public loggingService: LoggingService,
              public router: Router) {
    super(resizeService, ngZone, 48);
    this.messageService.messageObservable.subscribe(message => {
      this.messageService.message = message;
      this.ngZone.run(() => {
        switch (message.type) {
          case 'info':
            this.messageBar.openFromComponent(InfoMessageComponent, {
              duration: 3000,
              panelClass: 'my-custom-snackbar'
            });
            break;
          case 'error':
            this.messageBar.openFromComponent(ErrorMessageComponent, {
              duration: 3000,
              panelClass: 'my-custom-snackbar'
            });
            break;
          default:
        }
      });
    });
    // https://stackoverflow.com/a/35912966
    this.router.events.subscribe(async (event) => {
      if (event instanceof NavigationEnd) {
        const url = event.url;
        const urlArr = url.split('/');
        // '/auth/login'という形でPathが取得される
        if (urlArr && urlArr.length > 1) {
          this.currentRootRoute = urlArr[1];
          console.log(this.currentRootRoute);
        }
        // 例: ログ書き込み access URL変更時にログを出力
        // await firstValueFrom(this.loggingService.info(
        //   location.href,
        //   'access',
        // ));
      }
    });
    const bl = browserLanguage();
    const tl = translateLanguage();

    dateAdapter.setLocale(bl); // Datepicker の多言語化
    translateService.use(tl); // 表示言語
    document.documentElement.lang = tl; // <html> に lang="xxx" を設定。言語に応じたフォントを指定するため。 styles.scss の body:lang(ja) 等。

  }
}
